import "./css/login.css"
import { Link, useNavigate } from "react-router-dom"
import { useState, useEffect } from "react"

const pageName = "Login"

const Login = () => {
    const navigate = useNavigate()
    const [showPassword, setShowPassword] = useState(false)
    const [closeErrorMessage, setCloseErrorMessage] = useState(true)
    const [errorMessage, setErrorMessage] = useState()
    const [mail, setMail] = useState("")
    const [password, setPassword] = useState("")
    const [errorMail, setErrorMail] = useState()
    const [errorPassword, setErrorPassword] = useState()

    // Fix 1: Prevent Infinite Loop
    useEffect(() => {
        if (
            localStorage.getItem("name") !== null
            && localStorage.getItem("email") !== null
            && localStorage.getItem("status") !== null
            && localStorage.getItem("token") !== null
            && localStorage.getItem("user_id") !== null
        ) {
            navigate("/profile")
        } else if (
            localStorage.getItem("name") === null
            || localStorage.getItem("email") === null
            || localStorage.getItem("status") === null
            || localStorage.getItem("token") === null
            || localStorage.getItem("user_id") === null
        ) {
            localStorage.clear();
        }
    }, [navigate])

    useEffect(() => {
        const handleKeyDown = () => {
            if (mail.length > 0) setErrorMail("");
            if (password.length > 0) setErrorPassword("");
        };
        window.addEventListener("keypress", handleKeyDown);
        return () => window.removeEventListener("keypress", handleKeyDown);
    }, [mail, password])

    const clearErrors = () => {
        setErrorMail("")
        setErrorPassword("")
    }

    const validateClientSide = () => {
        let isValid = true;
        clearErrors();

        if (!mail.trim()) {
            setErrorMail("Enter your E-mail address.");
            isValid = false;
        } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(mail)) {
            setErrorMail("Your Email format is not valid.");
            isValid = false;
        }

        if (!password) {
            setErrorPassword("Enter your password.");
            isValid = false;
        } else if (password.length < 6) {
            setErrorPassword("Enter password at least 6 characters.");
            isValid = false;
        } else if (password.length > 25) {
            setErrorPassword("Maximum password length is 25 characters.");
            isValid = false;
        }

        return isValid;
    }

    const login = async (e) => {
        if (e) e.preventDefault(); 
        if (!validateClientSide()) return; 

        // Fix 2: try...catch for handling Network / Server Errors
        try {
            const response = await fetch(process.env.REACT_APP_SERVER_URL + "/user/login", {
                method: "POST",
                body: JSON.stringify({ email: mail, password: password }),
                headers: {
                    "Content-Type": "application/json"
                }
            })

            const result = await response.json()
            
            // Fix: Handle non-OK responses (like 429 rate limit block, 401 error) or false status
            if (!response.ok || result.status === false) {
                setCloseErrorMessage(false) 
                setErrorMessage(result.message || "Login failed. Please check your credentials.")
                return;
            } 
            
            // If login is successful
            if (result.status === true) {
                localStorage.clear()
                localStorage.setItem("token", result.token)
                localStorage.setItem("user_id", result.data.user_id)
                localStorage.setItem("name", result.data.name)
                localStorage.setItem("email", result.data.email)
                localStorage.setItem("status", result.data.status)
                navigate("/test")
            }
        } catch (error) {
            console.error("Login Error: ", error);
            setCloseErrorMessage(false);
            setErrorMessage("Error connecting to the server. Please try again later.");
        }
    }

    return (
        <div className="authPageWrapper">
            <div className="authMainContainer">
                <div className="authImageSection loginImageBg">
                </div>

                <div className="authFormSection">
                    <div className="authFormHeader">
                        <h2>Welcome Back</h2>
                        <p>Please login to your account</p>
                    </div>
                    
                    <form className="authForm" onSubmit={login}>
                        
                        <div className="inputGroup">
                            <label htmlFor="loginmain">E-mail</label>
                            <div className="inputWrapper">
                                <i className="fa-solid fa-envelope inputIcon"></i>
                                <input type="text"
                                    id="loginmain"
                                    name="userloginmail"
                                    placeholder="Enter your email"
                                    value={mail}
                                    onChange={(e) => setMail(e.target.value)}
                                />
                            </div>
                            {errorMail && <span className="errorText">{errorMail}</span>}
                        </div>

                        <div className="inputGroup">
                            <label htmlFor="loginpassword">Password</label>
                            <div className="inputWrapper">
                                <i className="fa-solid fa-lock inputIcon"></i>
                                <input type={showPassword ? "text" : "password"}
                                    id="loginpassword"
                                    name="userloginpassword"
                                    placeholder="Enter your password"
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                />
                                <button type="button" className="passwordToggle" onClick={() => setShowPassword(!showPassword)}>
                                    {showPassword ? <i className="fa-solid fa-eye-slash"></i> : <i className="fa-solid fa-eye"></i>}
                                </button>
                            </div>
                            {errorPassword && <span className="errorText">{errorPassword}</span>}
                        </div>

                        <div className="authFormActions">
                            <Link to="/forgetpassword" className="forgotLink">Forgot Password?</Link>
                        </div>

                        <button type="submit" className="submitBtn">{pageName}</button>

                        <div className="authFormFooter">
                            <p>Don't have an account? <Link to="/signup">Sign up</Link></p>
                        </div>
                    </form>
                </div>
            </div>

            {!closeErrorMessage && (
                <div className="authModalOverlay">
                    <div className="authModalBox">
                        <i className="fa-solid fa-circle-exclamation errorIcon"></i>
                        <p className="modalMessage">{errorMessage}</p>
                        <button className="modalBtn" onClick={() => setCloseErrorMessage(true)}>Ok</button>
                    </div>
                </div>
            )}
        </div>
    )
}

export default Login